// Layout shell shared by every public route (Editorial Warm marketing
// surface). Renders the editorial header + footer, mounts the floating
// SMS launcher, and owns the BookingModal's open/close state.
//
// Any descendant can pop the booking modal by dispatching a
// `nala-open-booking` window event. We chose CustomEvents over a
// React Context here because: (a) the modal can be invoked from
// anywhere in the tree without prop-drilling or provider plumbing,
// and (b) it lets us trigger the modal from raw DOM (e.g. anchor
// clicks) without a ref.

import { useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'
import EditorialHeader from './EditorialHeader'
import EditorialFooter from './EditorialFooter'
import SmsChat from './SmsChat'
import BookingModal from './BookingModal'
import { nala } from './palette'

export default function EditorialLayout() {
  const [bookOpen, setBookOpen] = useState(false)

  useEffect(() => {
    const onOpen = () => setBookOpen(true)
    window.addEventListener('nala-open-booking', onOpen)
    return () => window.removeEventListener('nala-open-booking', onOpen)
  }, [])

  return (
    <div
      className="min-h-screen flex flex-col"
      style={{ background: nala.bg, color: nala.ink, fontFamily: nala.sans }}
    >
      <EditorialHeader />
      <main className="flex-1">
        <Outlet />
      </main>
      <EditorialFooter />
      <SmsChat />
      <BookingModal open={bookOpen} onClose={() => setBookOpen(false)} />
    </div>
  )
}
